import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/UKG/GeneralAwareness";
import { Helmet } from "react-helmet";

const GeneralAwareness: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - UKG - General Awareness"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Explore UKG General Awareness worksheets on Mama’s Guidance, featuring fun and educational activities about festivals, community helpers, transport, and everyday surroundings to build foundational knowledge in young learners.' />
            </Helmet>
            <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
        </>
    );
};
export default GeneralAwareness;